import { render, staticRenderFns } from "./customerProject.vue?vue&type=template&id=5956e3d8&"
import script from "./customerProject.vue?vue&type=script&lang=js&"
export * from "./customerProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports